import { render, staticRenderFns } from "./AvatarHeader.vue?vue&type=template&id=30b0b76f&scoped=true&"
import script from "./AvatarHeader.vue?vue&type=script&lang=ts&"
export * from "./AvatarHeader.vue?vue&type=script&lang=ts&"
import style0 from "./AvatarHeader.vue?vue&type=style&index=0&id=30b0b76f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30b0b76f",
  null
  
)

export default component.exports